import React from 'react';
import { Box } from '@sparrowengg/twigs-react';
import Navbar from 'commons/components/navbar';
import AppStorage from 'features/apps/add-local-dev-app/components/app-storage';

const AppStoragePage = () => {
  return (
    <Box css={{ height: '100vh', width: '100vw', overflow: 'hidden' }}>
      <Navbar showPreviousBtn={false} />
      <AppStorage />
    </Box>
  );
};

export default AppStoragePage;
